import styled from '@emotion/styled';
import {
  Button,
  IconScaleStars as IconScaleStarsComponent,
  SkeletonBox,
} from '@presentation/components';
import { mediaQuery } from '@presentation/styles';
// Can't import from root because index exports are sorted to support dependencies
import { DetailList as DetailListComponent } from '../DetailList';

export const Wrapper = styled.div``;

export const Header = styled.div`
  box-shadow: 0 0 14px 0 rgba(0, 0, 0, 0.15);
  background: ${(props) => props.theme.color.light.tint};
  border-radius: 10px;
  padding: 20px 40px;
  margin-bottom: 40px;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-items: center;
  & > *:not(:last-child) {
    margin-right: 40px;
  }
  ${mediaQuery('tablet')} {
    flex-direction: column;
    & > *:not(:last-child) {
      margin-right: 0;
      margin-bottom: 20px;
    }
  }
`;

export const AverageWrapper = styled.div`
  font-size: 30px;
  font-weight: 700;
  color: ${(props) => props.theme.color.yellow.default};
  display: flex;
  align-items: center;
  & > *:not(:last-child) {
    margin-right: 10px;
  }
`;

export const IconScaleStars = styled(IconScaleStarsComponent)`
  font-size: 22px;
`;

export const DetailList = styled(DetailListComponent)`
  flex: 1;
`;

export const AmountText = styled.div`
  color: ${(props) => props.theme.color.medium.default};
  font-size: 16px;
`;

export const ItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  /* & > *:not(:last-child) {
    margin-bottom: 25px;
  } */
`;
export const AnswerWrapper = styled.div`
  display: flex;
  padding-left: 35px;
  & > *:not(:last-child) {
    margin-right: 15px;
  }
  align-items: flex-start;
  &:not(:last-child) {
    padding-bottom: 25px;
  }
  ${mediaQuery('phone')} {
    & > *:not(:last-child) {
      margin-right: 0;
      margin-bottom: 15px;
    }
    padding-left: 15px;
    flex-direction: column;
    justify-items: center;
  }
`;

export const ItemWrapper = styled.div<{ hasAnswer?: boolean }>`
  display: flex;
  & > *:not(:last-child) {
    margin-right: 15px;
  }
  align-items: flex-start;
  padding-bottom: ${(props) => (props.hasAnswer ? '15px' : '25px')};

  &:not(:last-child) {
    padding-bottom: ${(props) => (props.hasAnswer ? '15px' : '25px')};
  }
  ${mediaQuery('phone')} {
    & > *:not(:last-child) {
      margin-right: 0;
      margin-bottom: 15px;
    }
    flex-direction: column;
    justify-items: center;
  }
`;

export const ItemImage = styled.img`
  object-fit: cover;
  width: 64px;
  height: 64px;
  border-radius: 100%;
  margin: 0;
`;

export const ItemHeader = styled.div`
  font-weight: 700;
  font-size: 16px;
  align-items: center;
  display: flex;
  margin-bottom: 5px;
  & > *:not(:last-child) {
    margin-right: 10px;
  }
`;

export const ItemDescription = styled.div`
  margin-bottom: 15px;
  font-size: 16px;
  white-space: pre-line;
`;

export const ItemFooter = styled.div`
  font-size: 14px;
  display: flex;
  align-items: flex-end;
  color: ${(props) => props.theme.color.medium.default};
  & > *:not(:last-child) {
    margin-right: 15px;
  }
`;

export const ItemVerified = styled.div`
  cursor: pointer;
  width: 16px;
  height: 16px;
  color: ${(props) => props.theme.color.blue.default};
`;

export const FooterDate = styled.span`
  width: 100%;
  align-self: center;
`;
export const FooterButton = styled(Button)`
  margin: 0px;
  padding: 0px;
  align-self: center;
  width: auto;
  height: auto;
`;
export const AnswerCreationWrapper = styled.div``;

export const TextareaWrapper = styled.div`
  margin-bottom: 15px;
  font-size: 16px;
  width: 100%;
  white-space: pre-line;
`;

export const SkeletonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding-left: 35px;
`;
export const SkeletonContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-left: 15px;
`;
export const BreederPicSkeleton = styled(SkeletonBox)`
  object-fit: cover;
  width: 64px;
  height: 64px;
  border-radius: 100%;
  margin: 0;
`;
